export const PageHeader = ({ eyebrow, title, text, children }) => (
  <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div className="fade-up">
      <span className="eyebrow-label">{eyebrow}</span>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-[#0f172a] sm:text-4xl">{title}</h1>
      {text && <p className="mt-2 max-w-2xl text-sm text-[#64748b] sm:text-base">{text}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
